import { render, staticRenderFns } from "./overview-tables.vue?vue&type=template&id=bb73486a&scoped=true&"
import script from "./overview-tables.vue?vue&type=script&lang=js&"
export * from "./overview-tables.vue?vue&type=script&lang=js&"
import style0 from "./overview-tables.vue?vue&type=style&index=0&id=bb73486a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb73486a",
  null
  
)

export default component.exports